import * as React from "react";
import "../../../assets/scss/components/login/generic/loginErrMsg.scss";

export interface ILoginErrMsgProps {
	className?: string; // extra classname(s) if necessary
}

const LoginErrMsg: React.FC<ILoginErrMsgProps> = props => {
	return <p className={"login_err_msg pd-all10 " + (props.className || "")}>{props.children}</p>;
};

export default LoginErrMsg;
